let UTILS = require("../libs/utils.js");
var v7728;
var v7729;
module.exports = {
  id: "trade",
  name: "Trade",
  sendR: 5,
  endStats: ["sid", "name", "score"],
  alias: "trade",
  noClientKick: true,
  canTrade: true,
  friendly: true,
  noHPbars: true,
  viewDis: 500,
  nameDist: 60,
  gameTime: 0,
  maxNoMov: 180000,
  noMinimap: true
};